// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"b26ac15f","787":"c209630c"}[chunkId] + ".chunk.js";
};